import React from 'react';

import { Paper, Link, Logo } from 'ibnsina-ui';

import styles from './AuthLayout.module.scss';

const randomImages = [
    '/assets/images/guest-randoms/1.jpg',
    '/assets/images/guest-randoms/2.jpg',
    '/assets/images/guest-randoms/3.jpg',
    '/assets/images/guest-randoms/4.jpg',
    '/assets/images/guest-randoms/5.jpg',
    '/assets/images/guest-randoms/6.jpg',
    '/assets/images/guest-randoms/7.jpg',
    '/assets/images/guest-randoms/8.jpg',
    '/assets/images/guest-randoms/9.jpg',
    '/assets/images/guest-randoms/10.jpg',
    '/assets/images/guest-randoms/11.jpg',
    '/assets/images/guest-randoms/12.jpg',
    '/assets/images/guest-randoms/13.jpg',
    '/assets/images/guest-randoms/14.jpg',
];

const randomNumber = Math.floor(Math.random() * randomImages.length);

export default function AuthLayout({
    children,
}: {
    children: React.ReactNode;
}): JSX.Element {
    return (
        <main>
            <div className={styles['app-container']}>
                <aside className={styles['random-image']}>
                    <img
                        src={randomImages[randomNumber]}
                        loading="lazy"
                        alt="Ibn Sina Pharma login screen random pic"
                    />
                </aside>
                <section className={styles['page-wrapper']}>
                    <header className={styles['guest-header']}>
                        <Logo source="/assets/images/svgs/logo.svg" />
                    </header>
                    <Paper
                        paperType="outter-shadow"
                        paperSize="large"
                        className={styles['page-content']}>
                        {children}
                    </Paper>
                    <footer className={styles['guest-footer']}>
                        <small className={styles['smalls']}>
                            By continuing you accept our{' '}
                            <Link
                                className={styles['link']}
                                text="Terms of Use"
                                url="terms"
                            />{' '}
                            and{' '}
                            <Link
                                className={styles['link']}
                                text="Privacy Policy"
                                url="privacy"
                            />
                            .
                        </small>
                    </footer>
                </section>
            </div>
        </main>
    );
}
